import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { Box, IconButton, Typography } from '@mui/material';
import React from 'react';
import { themeColors } from '../../JuvareTheme';
import { useCommonWebTranslation } from '../../hooks';
export const GlobalTabLabel = ({ tabs, selectedTabPath, tab, onCloseTab }) => {
    const { t } = useCommonWebTranslation();
    const handleClose = (tab) => {
        var _a;
        const selectedTabIndex = tabs.findIndex((tab) => tab.path === selectedTabPath);
        const selectedTab = selectedTabIndex !== -1 ? tabs[selectedTabIndex] : undefined;
        let nextSelectedTab = selectedTab;
        if (tab === selectedTab) {
            nextSelectedTab = (_a = tabs[selectedTabIndex + 1]) !== null && _a !== void 0 ? _a : tabs[selectedTabIndex - 1];
        }
        onCloseTab(tab, nextSelectedTab);
    };
    return (React.createElement(Box, { sx: { display: 'flex', alignItems: 'center' } },
        tab.badge && (React.createElement(Box, { sx: { display: 'flex', color: themeColors.accent.red.bold, pr: 1 }, "data-test": 'badge', "aria-label": t('globalTabsBar.badge') },
            React.createElement(FiberManualRecordIcon, { fontSize: 'inherit' }))),
        tab.icon && (React.createElement(Box, { sx: { display: 'flex', color: themeColors.text.link, pr: 1 }, "data-test": 'icon' }, tab.icon)),
        React.createElement(Typography, { variant: 'button', sx: {
                color: themeColors.text.link,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '185px',
            }, "data-test": 'label', title: tab.label }, tab.label),
        React.createElement(IconButton, { component: 'div', onClick: (event) => {
                event.stopPropagation();
                handleClose(tab);
            }, sx: { ml: 1, p: 0 }, "data-test": 'close', "aria-label": t('globalTabsBar.close'), tabIndex: -1 },
            React.createElement(CancelOutlinedIcon, { fontSize: 'small', sx: { color: themeColors.text.link } }))));
};
